export const CDN_HOST = process.env.CDN_HOST || 'https://cdn.cineplex.de';